// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

function NoApiResponse() {
  return (
    <div id="noAPIResponse">
      <p>
        No API response, no data to display.
      </p>
      <p>
        We are trying to fix this as soon as possible
        <span className="loader-space" />
      </p>
      <p>Please come back later</p>
      <div><span className="loader" /></div>
    </div>
  );
}

export default NoApiResponse;
